import { IPackingAlgorithm } from "./common";
import { GridState, GridItem } from "../gridState";
import { GridPosition } from "client/Api/Workspace/common";
import { GridSpaceTracker } from "./gridSpaceTracker";


class LargeToSmallTopLeftFillPackingAlgorithm implements IPackingAlgorithm {

	private readonly _desiredColumnSpan: number;

	constructor(desiredColumnSpan: number) {
		this._desiredColumnSpan = desiredColumnSpan;
	}

	public applyTo<TItem>(state: GridState<TItem>) {
		const desiredColumnSpan: number = this._desiredColumnSpan;

		const containsItemsWiderThanDesiredColumnSpan: boolean = state.gridItems.some(
			(item) => item.dimension.columnSpan > desiredColumnSpan
		);

		if (containsItemsWiderThanDesiredColumnSpan) {
			throw new Error("Not all items fit within the given desired column span");
		}

		const orderedGridItems: GridItem<TItem>[] = [...state.gridItems].sort(this.compare);

		const tracker = new GridSpaceTracker(desiredColumnSpan);

		for (const gridItem of orderedGridItems) {
			const position: GridPosition = tracker.commitFirstAvailablePosition(gridItem.dimension);
			gridItem.position = position;
			tracker.resetFillingPosition();
		}
	}

	private compare<TItem>(a: GridItem<TItem>, b: GridItem<TItem>): number {
		if (a.dimension.columnSpan !== b.dimension.columnSpan) {
			// Descending
			return b.dimension.columnSpan - a.dimension.columnSpan;
		}
		if (a.dimension.rowSpan !== b.dimension.rowSpan) {
			// Descending
			return b.dimension.rowSpan - a.dimension.rowSpan;
		}

		if (a.position.row !== b.position.row) {
			return a.position.row - b.position.row;
		}

		return a.position.column - b.position.column;
	}
}

export {
	LargeToSmallTopLeftFillPackingAlgorithm
};